import React, {Component} from 'react';
import css from './SalesForceAccount.module.scss';
import axios from 'axios';
import {Formik, Form, Field, ErrorMessage} from "formik";
import ErrorLabel from "../../../components/ErrorLabel/ErrorLabel";
import {setUser} from "../../../store/actions";
import {connect} from "react-redux";


const SalesForceAccount = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // ---------- state: ----------
    state = {
        userName: ''
    };

    // ---------- life cycle methods: ----------
    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    resetApiTokenOnClick = () => {
        axios.post(
            '/settings/sf/resettoken',
            {},
            {
                cancelToken: this.source.token
            })
            .catch(err => console.log('(POST) Error trying to reset API token: \n', err));
    };

    updateDisplayedUser = (apiId) => {
        // we need to find the (selected) user object based on apiId - this requires an API call:
        axios.get(
            '/user/contact/all',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // process the list of contacts to a (flat) array of objects:
                let contacts = [];
                for (let key in res.data) {
                    if (res.data.hasOwnProperty(key)) {
                        contacts  = [...contacts, ...res.data[key]];
                    }
                }

                // find user and then update Redux store:
                let user = contacts.find(item => item.Id === apiId);
                // map contact's user object to data structure we are expecting:
                user = {
                    username: user.Email,
                    email: user.Email,
                    apiId: user.Id,
                    id: user.localId,
                    name: user.Name,
                    // n.b. `role` and `subrole` properties coming from `/user/contact/all` endpoint may be different (missing values) than the ones from initial login (citation needed):
                    role: user.role,
                    subrole: user.subrole
                };

                if (user) {
                    this.props.dispatch(setUser({
                        user,
                        isLoggedIn: true
                    }));
                }
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error:\n', err);
                }
            });
    };

    render() {
        return (
            <div className={css.SalesForceAccount}>
                <Formik
                    initialValues={{
                        apiValue: '',
                        userName: '',
                    }}

                    validate={
                        (values)=> {
                            const errors = {};

                            // flatten `userData` list so that it is a list of objects (each object is a user):
                            // n.b. we could set this to state during `componentDidMount` since it doesn't depend on any user input:
                            const usersList = Object.keys(this.props.userData)
                                .map(office => this.props.userData[office])
                                .reduce((prev, current, index, list) => {
                                    return [...prev, ...current];
                                });

                            // find user based on the API Id provided in user input:
                            const user = usersList.find(user => user.Id === values.apiValue);

                            // check if user exists:
                            if(!user || !user.Name) {
                                errors.apiValue = "No records found for given API ID";
                            // since we can't assign properties to `values`, we use state to update the user name:
                            } else {
                                this.setState({userName: user.Name});
                            }

                            return errors;
                        }
                    }

                    onSubmit={
                        (values) => {
                            const payload = {
                                apiId: values.apiValue,
                                name: this.state.userName
                            };

                            axios.post(
                                '/settings/changeapi',
                                payload,
                                {
                                    cancelToken: this.source.token
                                })
                                .then((res) => {
                                    // if request is successful, then the back-end has already updated the user (see `changeApiId` in `/backend`)
                                    // however, we need to update the displayed user info and update Redux store with the new user object:
                                    this.updateDisplayedUser(values.apiValue);
                                })
                                .catch(err => console.log('(POST) Error trying to change API: ', err));
                        }
                    }
                >
                    <Form>
                        <table>
                            <tbody>
                            <tr className="d-flex flex-column d-md-table-row">
                                <td>Refresh SF Login Token</td>
                                <td></td>
                                <td>
                                    <button className="btn btn-primary" type="button" onClick={() => this.resetApiTokenOnClick()}>Refresh API Token</button>
                                </td>
                            </tr>
                            <tr className="d-flex flex-column d-md-table-row">
                                <td>Be Sales Rep</td>
                                <td>
                                    <div><span className="font-weight-bold">SF Id</span></div>
                                    <div>
                                        <Field className="input input-plain" type="text" placeholder="API Id" name="apiValue" />
                                        <ErrorMessage name="apiValue" component={ErrorLabel} />
                                    </div>
                                </td>
                                <td>
                                    <button className="btn btn-primary" type="submit">Change API Id</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Form>
                </Formik>
            </div>
        );
    };
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user,
        isLoggedIn: state.isLoggedIn
    };
};

export default connect(mapStateToProps)(SalesForceAccount);
